import { StyleSheet, View } from "react-native";
import { ReadOnlyMenuItem } from "./ReadOnlyMenuItem";
export const ReadOnlyMenuList = ({ menus, selectedMenuIds, }) => {
    return (<View style={styles.container}>
      {menus
            .filter((menu) => selectedMenuIds.length === 0 ||
            selectedMenuIds.includes(Number(menu.id)))
            .map((menu) => (<ReadOnlyMenuItem key={menu.id} item={menu}/>))}
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
        gap: 8,
        position: "relative",
    },
});
//# sourceMappingURL=ReadOnlyMenuList.js.map